import { createSlice, ActionReducerMapBuilder } from '@reduxjs/toolkit';

export interface IDataTableState {
  queryKey: (string | number)[];
  filters: Record<string, any>;
  pagination: {
    page: number;
    limit: number;
  };
}

const initialState: IDataTableState = {
  queryKey: [],
  filters: {},
  pagination: {
    page: 1,
    limit: 10,
  },
};

const dataTableSlice = createSlice({
  name: 'dataTable',
  initialState,
  reducers: {
    setQueryKey: (state, action) => {
      state.queryKey = action.payload;
    },
    setFilters: (state, action) => {
      state.filters = action.payload;
    },
    setPagination: (state, action) => {
      state.pagination = action.payload;
    },
    reset: (state) => {
      state.queryKey = [];
      state.filters = {};
      state.pagination = {
        page: 1,
        limit: 10,
      };
    },
  },
  extraReducers: (builder: ActionReducerMapBuilder<IDataTableState>) => {
    //
  },
});

export default dataTableSlice.reducer;

export const { setQueryKey, setFilters, setPagination, reset } = dataTableSlice.actions;
